module.exports = {
  NO_FOCUS_BOX: 0,
  RFI_REASON: 1,
  DELIVERY_IMAGE: 2,
  COLLECT_FROM_DEPOT_INSTRUCTIONS: 3,
  PICKUP_DELIVERY: 4,
  PICKUP_DELIVERY_COLLECTED: 5,
  OUT_FOR_DELIVERY: 6,
  ISSUE: 7,
  ESTIMATED_DATE: 8,
  APP_SHIPPING: 9,
};
